import { FC } from "react";
import { CalendarHeader } from "components";

interface OfficeHeaderProps {
  renderActions?: FC<{}>;
  views?: string[];
  defaultView?: string
}

const OfficeHeader: FC<OfficeHeaderProps> = ({ renderActions, views, defaultView }) => {
  
  return (
    <CalendarHeader
      renderActions={renderActions}
      views={views}
      defaultView={defaultView}
    />
  );
};

export default OfficeHeader;
